module.exports = __webpack_public_path__ + "images/bancontact.5fc57efe898f851cf3b60c995edb6757.svg";